import * as React from "react";
import { memo } from "react";
const SvgLandingTopSliver = (props) => /* @__PURE__ */ React.createElement("svg", { preserveAspectRatio: "none", xmlns: "http://www.w3.org/2000/svg", width: 416, height: 18, viewBox: "0 0 416 18", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M56.4376 0H416V18H0L56.4376 0Z", fill: "#011936" }));
const Memo = memo(SvgLandingTopSliver);
export default Memo;
